import { BarChart } from "@mui/x-charts";

export default function SimpleBarChart({ series = [], xAxis = [] }) {
  return <BarChart series={series} xAxis={xAxis}></BarChart>;
}
